import { MeetingDetailWithContext } from '../meeting_detail'
import { SearchMeetingProvider, SearchMeetingDetailContext } from './search_meeting_context'
import { MeetingDetailDependenciesProvider } from '../meeting_detail/meeting_detail_dependencies_provider'

export const SearchMeetingRightRail = ({ selectedMeetingId, isOrganizer, includeNotetakerIneligibleExternalEvents }) => (
  <MeetingDetailDependenciesProvider>
    <SearchMeetingProvider
      selectedMeetingId={selectedMeetingId}
      isOrganizer={isOrganizer}
      includeNotetakerIneligibleExternalEvents={includeNotetakerIneligibleExternalEvents}
    >
      <MeetingDetailWithContext context={SearchMeetingDetailContext} />
    </SearchMeetingProvider>
  </MeetingDetailDependenciesProvider>
)
